let Timeline = {
    setup: function(c) {
        //Home
        let animation1 = new TimelineMax()
            .add([
                TweenMax.fromTo('[data-component="home-hero"] .graphics-1', 1, {y: '0%'}, {y: '450%', ease: Linear.easeNone}),
                TweenMax.fromTo('[data-component="home-hero"] .graphics-2', 1, {y: '0%'}, {y: '250%', ease: Linear.easeNone}),
                TweenMax.fromTo('[data-component="home-hero"] .graphics-3', 1, {y: '0%'}, {y: '-50%', ease: Linear.easeNone}),
                TweenMax.fromTo('[data-component="home-hero"] .img-pets', 1, {y: '0%'}, {y: '15%', ease: Linear.easeNone}),
                TweenMax.fromTo('[data-component="home-hero"] .seal', 1, {y: '0%'}, {y: '80%', ease: Linear.easeNone}),
            ]);

        let scene1 = new ScrollMagic.Scene({
                triggerElement: 'main',
                triggerHook: 'onLeave',
                duration: '100%'
            })
            .setTween(animation1)
            .addTo(c);

        //Home
        let animation2 = new TimelineMax()
            .add([
                TweenMax.fromTo('.why-balance .box-graphics', 1, {y: '20%'}, {y: '-20%', ease: Linear.easeNone}),
            ]);

        let scene2 = new ScrollMagic.Scene({
                triggerElement: '.why-balance',
                triggerHook: 'onEnter',
                duration: '150%'
            })
            .setTween(animation2)
            .addTo(c);

        //Hero Produtos Home
        let animation3 = new TimelineMax()
            .add([
                TweenMax.fromTo('[data-component="pet-hero"] .box-image .kibbles-image', 1, {y: '0%'}, {y: '-5%', ease: Linear.easeNone}),
                TweenMax.fromTo('[data-component="pet-hero"] .box-image .pet-product-image', 1, {y: '0%'}, {y: '8%', ease: Linear.easeNone}),
            ]);

        let scene3 = new ScrollMagic.Scene({
                triggerElement: 'main',
                triggerHook: 'onLeave',
                duration: '100%'
            })
            .setTween(animation3)
            .addTo(c);

        //Hero Produtos List
        let animation4 = new TimelineMax()
            .add([
                TweenMax.fromTo('.hero-products .box-image .img-graphics', 1, {y: '0%'}, {y: '20%', ease: Linear.easeNone}),
                TweenMax.fromTo('.hero-products .box-image .img-photo', 1, {y: '0%'}, {y: '6%', ease: Linear.easeNone}),
            ]);

        let scene4 = new ScrollMagic.Scene({
                triggerElement: 'main',
                triggerHook: 'onLeave',
                duration: '100%'
            })
            .setTween(animation4)
            .addTo(c);

        //Home Sobre nos
        const duration5 = $('.about-us .box-about-us').height();
        let animation5 = new TimelineMax()
            .add([
                TweenMax.fromTo('.about-us .box-about-us .box-image .image-1', 1, {y: '30%'}, {y: '0%', ease: Linear.easeNone}),
                TweenMax.fromTo('.about-us .box-about-us .box-image .image-2', 1, {y: '20%'}, {y: '0%', ease: Linear.easeNone}),
            ]);

        let scene5 = new ScrollMagic.Scene({
                triggerElement: '.about-us',
                triggerHook: 'onEnter',
                duration: duration5
            })
            .setTween(animation5)
            .addTo(c);

        //Banner home saches
        let animation6 = new TimelineMax()
            .add([
                TweenMax.fromTo('[data-component="home-hero-saches"] .banner-hand', 1, {y: '0%'}, {y: '10%', ease: Linear.easeNone}),
            ]);

        let scene6 = new ScrollMagic.Scene({
                triggerElement: 'main',
                triggerHook: 'onLeave',
                duration: '100%'
            })
            .setTween(animation6)
            .addTo(c);

    }
};
